
import { IJob } from "@/Sites/IJob";
import {computed} from "@vue/reactivity"
import { Job } from "@/Sites/Job";
import { ref } from "vue";
import { ScheduleViewModel } from "../OfficerSchedule/ScheduleViewModel";
import { OfficerScheduleViewModel } from "../OfficerSchedule/OfficerScheduleViewModel";
import { IOfficerScheduleViewModel } from "../OfficerSchedule/IOfficerScheduleViewModel";

export default {
  name: "job-calls",
  props:["baseUrl"],
  setup(props: any) {
    const StartingJob = ref<ScheduleViewModel>() as any;
    const EndingJob = ref<ScheduleViewModel>() as any;
    const RunningJob = ref(null) as any;
    // const StartingJob = ref();
    var Guardtoken = localStorage.getItem("Guardtoken")!;
    var OfficerId = localStorage.getItem("OfficerId")!;

    const baseUrlAddress = computed(() => {
      return `${props.baseUrl}`;
    });
    
    const  GetCurrentJobsForOfficer = function () {
      StartingJob.value = null;
      EndingJob.value = null;
      RunningJob.value = null;
      GetStartingJobForOfficer("StartingJobForOfficer");
      GetStartingJobForOfficer("EndingJobForOfficer");
      GetStartingJobForOfficer("CheckcallStatusForOfficer");
    };

    const GetStartingJobForOfficer = function (endpoint: string) {
      // StartingJob.value = null;
      //let requestUrl = "https://localhost:44325/Schedule/" + endpoint; //"StartingJobForOfficer"
      // let requestUrl = "http://emergingsols2.somee.com/Schedule/" + endpoint; //"StartingJobForOfficer"
      
      let requestUrl = baseUrlAddress.value+ "Schedule/" + endpoint; //"StartingJobForOfficer"

      // let requestUrl = props.baseUrl + "Schedule/StartingJobForOfficer";
      // console.log("requestUrl : ", requestUrl);

      let requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Guardtoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: parseInt(OfficerId),
        }),
      };
      fetch(requestUrl, requestOptions).then((response) => {
        response
          .json()
          .then((job) => {
            //StartingJob.value = job.responseResult.response.scheduleViewModel;
            //console.log("StartingJob.value ", StartingJob.value);
            console.log(
              "job.responseResult.response ",
              job.responseResult.response
            );
            return job.responseResult.response;
          })
          .then((j) => {
            if(j == null)
            return;
            switch (endpoint) {
              case "StartingJobForOfficer":
                StartingJob.value = j.scheduleViewModel;
                console.log("StartingJob.value ", StartingJob.value);
                break;

              case "EndingJobForOfficer":
                EndingJob.value = j.scheduleViewModel;
                console.log("EndingJob.value ", EndingJob.value);
                break;

              case "CheckcallStatusForOfficer":
                console.log("RunningJob", j);
                console.log(
                  "RunningJob.isCheckCallRequired",
                  j.isCheckCallRequired
                );
                console.log("RunningJob.jobId", j.jobId);
                if (j.isCheckCallRequired)
                  RunningJob.value = {
                    jobId: j.jobId,
                    isCheckCallRequired: j.isCheckCallRequired,
                  };
                console.log("RunniningJob.value ", RunningJob.value);
                break;
            }
          });
      });
    };

    const getLocation = () => {
      return new Promise((resolve, reject) => {
        var address: Promise<any> | null = null;
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            // console.log("pos.coords.longitude", pos.coords.longitude);
            // console.log("pos.coords.latitude", pos.coords.latitude);

            let requestUrl =
              "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
              pos.coords.longitude +
              "," +
              pos.coords.latitude +
              ".json?access_token=pk.eyJ1Ijoic2hvdWtldGFsaSIsImEiOiJja3Vicmxqb3UwYzlnMnFvNmNhMDJ5dmJiIn0.bsT85MRV63Qr_kyl2RpJbQ";

            let requestOptions = {
              method: "GET",
              headers: {
                "content-type": "application/json",
              },
            };
            fetch(requestUrl, requestOptions).then((response) => {
              response.json().then((result) => {
                if (result?.features.length > 0) {
                  address = result.features[0].place_name;
                }
                // console.log("addresses", address);
                resolve({ address: address, pos: pos });
              });
            });
          },
          (err) => {
            reject(err);
          }
        );
      });
    };

    const InsertCheckCall = function (
      jobId: number,
      callTypeId: number,
      callType: string,
      remarks: string
    ) {
      console.log(
        "Test log statement for jobId in InsertCheckCall =",
        StartingJob.value
      );

      //let jobId = StartingJob.value.jobId; //1; //job.jobId;//1;//

      let longitude = 0;
      let latitude = 0;
      let altitude = 0;
      let address = "";
      getLocation()
        .then((res: any) => {
          //alert("res : " + res);
          // console.log("res", res);
          // console.log(" res.pos.coords", res.pos.coords);
          longitude = res.pos.coords.longitude;
          latitude = res.pos.coords.latitude;
          address = res.address;

          // console.log("longitude", longitude, "latitude", latitude);

          //let requestUrl = "https://:44325/" + "JobCalls/AddJobCall";//http://emergingsols.somee.com/
          //let requestUrl = "http://emergingsols2.somee.com/" + "JobCalls/AddJobCall";
          let requestUrl = baseUrlAddress.value + "JobCalls/AddJobCall";
          let requestOptions = {
            method: "POST",
            headers: {
              // Authorization: `Bearer ${localStorage.Guardtoken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              Id: 0,
              JobId: jobId,
              Location: longitude + ", " + latitude + ", " + altitude,
              CallTypeId: callTypeId, //1, //callTypeId,
              CallType: callType, //"Duty Start Call", //start-duty call
              Remarks: address,
              CallTime: new Date(),
            }),
            // body: JSON.stringify({
            //   Id: 0,
            //   JobId: jobId,
            //   Location:
            //     longitude +
            //     ", " +
            //     latitude +
            //     ", " +
            //     altitude +
            //     "(" +
            //     address +
            //     ")",
            //   CallTypeId: callTypeId, //1, //callTypeId,
            //   CallType: callType, //"Duty Start Call", //start-duty call
            //   Remarks: remarks,
            //   CallTime: new Date(),
            // }),
          };

          fetch(requestUrl, requestOptions)
            .then((response) => {
              response.json();
              GetCurrentJobsForOfficer();
            })
            .then((res) => {
              console.log(
                "TODO : End of Update. Here an appropriate message should be written"
              );
            });
        })
        .catch((error) => {
          console.log("error occured while addingJobCall", error);
        });
    };

    GetCurrentJobsForOfficer();
    // GetStartingJobForOfficer("StartingJobForOfficer");
    // GetStartingJobForOfficer("EndingJobForOfficer");

    //////////////////////// StartDutyCommand() ///////////////////////////////
    const DutyCommand = function (
      jobId: number,
      jobStatus: number,
      callTypeId: number,
      callType: string,
      remarks: string
    ) {
      console.log("Test log statement for jobId =", jobId);

      if (callTypeId == 2)
        //check-call
        InsertCheckCall(jobId, callTypeId, callType, remarks);
      else {
        // let requestUrl =
        //   //"https://localhost:44325/" + "Schedule/UpdateJobStatusNew";//http://emergingsols.somee.com/
        //   "http://emergingsols2.somee.com/" + "Schedule/UpdateJobStatusNew";//http://emergingsols.somee.com/

        let requestUrl =  baseUrlAddress.value + "Schedule/UpdateJobStatusNew";

        let requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.Guardtoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Id: jobId, //localStorage.getItem("officerId"), //1501,
            JobStatusId: jobStatus, //2, //set job-status to duty-started
          }),
        };

        fetch(requestUrl, requestOptions)
          .then((response) => response.json())
          .then((res) => {
            //if (res.responseStatus == 1) {
            console.log("status updated successfully......");
            InsertCheckCall(jobId, callTypeId, callType, remarks);
            // } else if (res.responseStatus != 1) {
            //   console.log("status could not be updated successfully----");
            // }
          });
      }

      GetCurrentJobsForOfficer();
      // GetStartingJobForOfficer("StartingJobForOfficer");
      // GetStartingJobForOfficer("EndingJobForOfficer");
    };

    return {
      // GetCurrentJobCalls,
      GetStartingJobForOfficer,
      GetCurrentJobsForOfficer,
      // StartDutyCommand,
      // EndDutyCommand,
      baseUrlAddress,
      DutyCommand,
      InsertCheckCall,
      StartingJob,
      EndingJob,
      RunningJob,
    };
  },
};
